import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import Alert from "@material-ui/lab/Alert";
import { useSelector } from "react-redux";

export default function AlphaAlert(props) {
  const { fixed, setFixed } = props;
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);

  return (
    <Alert
      icon={false}
      style={{
        width: isDesktopOrLaptop ? (fixed ? "100%" : "auto") : "95vw",
        height: fixed ? "100%" : isDesktopOrLaptop ? "45px" : "37px",
        border: fixed ? "" : "1.5px solid #ff9d00",
        borderTop: "1.5px solid #ff9d00",
        color: "#ff9d00",
        borderRadius: fixed ? "0px" : "5px",
        backgroundColor: "rgba(255, 157, 0, 0.05)",
        fontFamily: "Overpass",
        fontSize: isDesktopOrLaptop ? "16px" : "12px",
        fontWeight: 600,
        letterSpacing: "normal",
        display: "flex",
        alignItems: "center",
        justifyContent: isDesktopOrLaptop
          ? fixed
            ? "center"
            : "flex-start"
          : "center",
        padding: isDesktopOrLaptop ? "0 7px 0 14px" : "0",
      }}
    >
      ✋ {props.text}
      {fixed ? (
        <span style={{ marginLeft: "37px" }}>
          <IconButton
            size="small"
            onClick={() => {
              setFixed(false);
            }}
          >
            <Close
              style={{ height: "13px", width: "13px", color: "#ff9d00" }}
            />
          </IconButton>
        </span>
      ) : null}
    </Alert>
  );
}
